import React, { useCallback, useEffect, useState } from "react";
import style from "./Cylinders.module.scss";
import { Button, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { LinearLoader } from "../../components/Loader/LinearLoader";
import Pagination from "../../components/paginationCopy/Pagination";
import Search from "../../components/search";
import {
  loadCylinderDetails,
  loadSeries,
} from "../../redux/admin/actions/admin.actions";
import { ConfirmationModal } from "../../components/Modal/ConfirmationModal";
import { SortButton } from "../../components/utils/sortButton";
import { MdOutlineKeyboardBackspace, MdQrCode2 } from "react-icons/md";
import GenerateCode from "./GenerateCode.component";
import { useNavigate } from "react-router-dom";
import { MyButton } from "../../Hooks/useButton";
import CylinderStats from "../../components/CylinderStats/CylinderStats";
import Filter from "../../components/search/searchFilter/Filter";
import { EyeOutlined } from "@ant-design/icons";
import CircularLoader from "../../components/Loader/CircularLoader";

const CylinderBatch = () => {
  const dispatch = useDispatch();
  const { cylinderDetails } = useSelector((state) => state.adminReducer);

  const [loading, setLoading] = useState(true);
  const [updateType, setUpdateType] = useState(false);
  const [dataMatch, setDataMatch] = useState("");

  const [searchTerm, setSearchTerm] = useState("");
  const [searchKey, setSearchKey] = useState("");
  const [filteredData, setFilteredData] = useState(cylinderDetails);

  const code = localStorage.getItem("batch");

  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    dispatch(loadCylinderDetails());
    setLoading(false);
  }, [code, dispatch]);

  useEffect(() => {
    const results = cylinderDetails?.filter((item) =>
      item[searchKey]?.toLowerCase()?.includes(searchTerm.toLowerCase())
    );
    setFilteredData(results);
  }, [cylinderDetails, searchKey, searchTerm]);

  // pagination
  const [pageNumber, setPageNumber] = useState(0);
  const size = 10;
  const pagesVisited = pageNumber * size;
  const pageCount = Math.ceil(
    filteredData >= 1
      ? filteredData?.length / size
      : cylinderDetails?.length / size
  );

  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  const handleRow = (data) => {
    setUpdateType(true);

    let match = cylinderDetails?.find((t) => t?.code === data?.code);
    if (match) {
      setDataMatch(match);
    }
  };

  // sorting
  const [sortKey, setSortKey] = useState("date_created");
  const [sortOrder, setSortOrder] = useState("desc");

  function sortData({ tableData, sortKey, reverse }) {
    if (!sortKey) return tableData;

    const sortedData = filteredData.sort((a, b) => {
      return a[sortKey] > b[sortKey] ? 1 : -1;
    });

    if (reverse) {
      return sortedData.reverse();
    }

    return sortedData;
  }

  const sortedData = useCallback(
    () =>
      sortData({
        tableData: filteredData,
        sortKey,
        reverse: sortOrder === "desc",
      }),
    [filteredData, sortKey, sortOrder]
  );

  const headers = [
    { key: "index", label: "S/N" },
    { key: "size_name", label: "Cylinder SIze" },
    { key: "series", label: "Code" },
    { key: "plant", label: "Owner" },
    { key: "date_created", label: "Date Created" },
  ];

  const changeSort = (key) => {
    setSortOrder(sortOrder === "ascn" ? "desc" : "ascn");
    setSortKey(key);
  };

  const handleView = (data) => {
    localStorage.setItem("batch", data?.series);
    // navigate(`/cylinders/${data?.series}`);
    window.location.href = `${data?.series}`;
  };

  const stats = [
    {
      name: "In System",
      value: "",
    },

    {
      name: "In Hospitals",
      value: "",
    },
    {
      name: "With Riders",
      value: "",
    },
    {
      name: "In Offices",
      value: "",
    },
    {
      name: "In Plants",
      value: "",
    },
  ];

  const searchKeys = [
    { id: "series", name: "Code" },
    { id: "plant", name: "Owner" },
  ];

  return (
    <>
      <div
        onClick={() => navigate(-1)}
        className='arrow'
        style={{ cursor: "pointer" }}
      >
        <MdOutlineKeyboardBackspace
          style={{
            color: "#fff",
            background: "#2784ef",
            borderRadius: "50%",
            padding: "4px",
          }}
          size={30}
        />{" "}
      </div>
      <div>
        <CylinderStats stats={stats} />
      </div>
      <div className='d-flex justify-content-between m-3'>
        <div> </div>
        {/* <Search placeholder='Search' onChange={handleChange} /> */}
        <Filter
          placeholder={"Search by"}
          filter={searchKey}
          options={searchKeys}
          onChange={(event) => {
            setSearchTerm(event.target.value);
          }}
          onChangeSelect={(event) => {
            setSearchKey(event.target.value);
          }}
        />{" "}
      </div>
      <section style={{ maxWidth: "95%", margin: "auto" }}>
        {/* {loading && <LinearLoader />} */}
        <Table borderless responsive className='mt-4'>
          <thead>
            <tr className={style.TableHeadRow}>
              {headers.map((row) => {
                return (
                  <td key={row.label}>
                    {row.label}{" "}
                    {filteredData?.length > 0 && (
                      <SortButton
                        bgColor={"#2784ef"}
                        columnKey={row.key}
                        onClick={() => changeSort(row.key)}
                        {...{ sortOrder, sortKey }}
                      />
                    )}
                  </td>
                );
              })}
            </tr>
          </thead>
          {filteredData?.length > 0 ? (
            <tbody>
              {sortedData()
                ?.slice(pagesVisited, pagesVisited + size)
                ?.map((hosp, index) => (
                  <tr
                    className={style.tableBodyRow}
                    key={hosp?.id}
                    // onClick={() => handleRow(hosp)}
                  >
                    <td style={{ width: "7vw" }}>
                      {" "}
                      {pageNumber * size + index + 1}
                    </td>
                    <td style={{ width: "15vw" }}>{hosp?.size_name}</td>
                    <td style={{ width: "15vw" }}>{hosp?.series}</td>
                    <td style={{ width: "15vw" }}>{hosp?.plant}</td>
                    <td style={{ width: "15vw" }}>{hosp?.date_created}</td>

                    <td className='d-flex gap-3 justify-content-center align-items-center'>
                      <MdQrCode2
                        className={style.action}
                        style={{
                          color: "#213f7d",
                          fontSize: "25px",
                          cursor: "pointer",
                        }}
                        onClick={() => handleRow(hosp)}
                      />{" "}
                      <EyeOutlined
                        className={style.action}
                        style={{ color: "#213f7d", fontSize: "19px" }}
                        onClick={() => handleView(hosp)}
                        // onClick={() => handleEdit(tick)}
                      />{" "}
                    </td>
                  </tr>
                ))}
            </tbody>
          ) : cylinderDetails && searchTerm === "" ? (
            <tbody>
              {cylinderDetails
                ?.slice(pagesVisited, pagesVisited + size)
                ?.map((hosp, index) => (
                  <tr
                    className={style.tableBodyRow}
                    key={hosp?.id}
                    // onClick={() => handleRow(hosp)}
                  >
                    <td style={{ width: "7vw" }}>
                      {" "}
                      {pageNumber * size + index + 1}
                    </td>
                    <td style={{ width: "15vw" }}>{hosp?.size_name}</td>
                    <td style={{ width: "15vw" }}>{hosp?.series}</td>
                    <td style={{ width: "15vw" }}>{hosp?.plant}</td>
                    <td style={{ width: "15vw" }}>{hosp?.date_created}</td>

                    <td className='d-flex gap-3 justify-content-center align-items-center'>
                      <MdQrCode2
                        className={style.action}
                        style={{
                          color: "#213f7d",
                          fontSize: "25px",
                          cursor: "pointer",
                        }}
                        onClick={() => handleRow(hosp)}
                      />{" "}
                      <EyeOutlined
                        className={style.action}
                        style={{ color: "#213f7d", fontSize: "19px" }}
                        onClick={() => handleView(hosp)}
                        // onClick={() => handleEdit(tick)}
                      />{" "}
                    </td>
                  </tr>
                ))}
            </tbody>
          ) : (
            <div className='d-flex justify-content-center align-items-center'>
              No record found
            </div>
          )}
        </Table>
        {(filteredData?.length < 1 && searchTerm === ""
          ? cylinderDetails?.length > size
          : filteredData?.length > size) && (
          <Pagination pageCount={pageCount} onPageChange={changePage} />
        )}
      </section>

      {/* update Modal */}
      <ConfirmationModal
        open={updateType}
        handleClose={() => setUpdateType(false)}
        closemodal={() => setUpdateType(false)}
        bgcolor=' rgba(255, 255, 255, 0.92)'
        width='20vw'
        instruction={<GenerateCode code={dataMatch?.series} />}
      />
    </>
  );
};

export default CylinderBatch;
